import Vue from 'vue'
import VueDatePicker from '@mathieustan/vue-datepicker'

// Options: You can set lang by default
Vue.use(VueDatePicker, {
  lang: 'nl'
})
